import apiClient from '@/lib/axios';
import type {
  JobCharge,
  ChargeTotal,
  CreateJobChargeRequest,
  UpdateJobChargeRequest,
} from '../types/jobCharge';

/**
 * Get all charges for a job
 */
export const getJobCharges = async (
  jobId: number,
  isForecast?: boolean
): Promise<JobCharge[]> => {
  const params = new URLSearchParams();
  if (isForecast !== undefined) {
    params.append('isForecast', isForecast.toString());
  }

  const response = await apiClient.get<{ data: JobCharge[] }>(
    `/jobs/${jobId}/charges${params.toString() ? `?${params.toString()}` : ''}`
  );
  return response.data.data;
};

/**
 * Get charge total for a job
 */
export const getJobChargeTotal = async (
  jobId: number,
  isForecast?: boolean
): Promise<ChargeTotal> => {
  const params = new URLSearchParams();
  if (isForecast !== undefined) {
    params.append('isForecast', isForecast.toString());
  }

  const response = await apiClient.get<{ data: ChargeTotal }>(
    `/jobs/${jobId}/charges/total${params.toString() ? `?${params.toString()}` : ''}`
  );
  return response.data.data;
};

/**
 * Create a new job charge
 */
export const createJobCharge = async (
  jobId: number,
  data: CreateJobChargeRequest
): Promise<JobCharge> => {
  const response = await apiClient.post<{ data: JobCharge }>(
    `/jobs/${jobId}/charges`,
    data
  );
  return response.data.data;
};

/**
 * Update an existing job charge
 */
export const updateJobCharge = async (
  jobId: number,
  chargeId: number,
  data: UpdateJobChargeRequest
): Promise<JobCharge> => {
  const response = await apiClient.put<{ data: JobCharge }>(
    `/jobs/${jobId}/charges/${chargeId}`,
    data
  );
  return response.data.data;
};

/**
 * Delete a job charge
 */
export const deleteJobCharge = async (
  jobId: number,
  chargeId: number
): Promise<void> => {
  await apiClient.delete(`/jobs/${jobId}/charges/${chargeId}`);
};
